import { render } from "./RewardList.vue?vue&type=template&id=24875422&scoped=true"
import script from "./RewardList.vue?vue&type=script&lang=js"
export * from "./RewardList.vue?vue&type=script&lang=js"

import "./RewardList.vue?vue&type=style&index=0&id=24875422&lang=scss&scoped=true"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24875422"]])

export default __exports__